// Mirrors the Spring `/api/posts` response; keep in sync with blog/posts/*.md.
export type Post = {
  slug: string;
  title: string;
  date: string;
  summary: string;
  tags: readonly string[];
  body: string;
};

export const posts: readonly Post[] = [
  {
    slug: 'starting-this-site',
    title: 'Starting this site',
    date: '2026-05-17',
    summary:
      'How this site started one night, the stack I picked, and coding from my phone.',
    tags: ['meta'],
    body: `
I bought this domain a few years ago but didn't actually start the site until
one night recently. I was out, but I wanted to see how far I could get just
talking to Claude on my phone. I gave it the exact stack to use, partly to learn
and partly to remember: a Java backend with Spring and Postgres, GCP and
Terraform, and React on the front end.

What surprised me is how much Claude 5X Max could do with just a personal access
token to a fresh GitHub repository. I had to ask for screenshots to actually see
the site, and I left the details to iron out once I was back at my desk.

There were a few details it got surprisingly wrong — like calling me "Tony
Kasparaitis." My name isn't Tony, and there's no Tony anywhere in our chats.

It was surprisingly nice to get a little work done, but I still have a hard time
imagining using it for anything significant. Mostly because that sort of thing
takes a lot more back-and-forth and steering. Or, for a well-specced ticket, I
don't see much difference between firing it off from my laptop to check on later
vs my phone.
    `.trim(),
  },
];
